import { render, staticRenderFns } from "./CustomerEnvironmentConfigurationList.vue?vue&type=template&id=4b131dd4&"
import script from "./CustomerEnvironmentConfigurationList.vue?vue&type=script&lang=js&"
export * from "./CustomerEnvironmentConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports